

export class Plane {
  planeId?:string;
  description?:string;
  planeColor?:string;
}
